import { RewardVault } from "@airdao/bond-periphery/core/contracts/types";
import { ContractNames, Contracts } from "@airdao/bond-periphery/core";
import { AddressLike } from "ethers";

export async function Claim(
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
  staker: AddressLike,
  amount: bigint,
  recipient: AddressLike,
) {
  const vault = contracts.getContractByName(
    contractName,
  ) as unknown as RewardVault;
  return await vault.claim(staker, amount, recipient);
}

export const UserMethods = {
  Claim
};

export default UserMethods;
